import num01 from '@/assets/svg/num_01.svg'
import num02 from '@/assets/svg/num_02.svg'
import num03 from '@/assets/svg/num_03.svg'
import num04 from '@/assets/svg/num_04.svg'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const SERVICE_BACKGROUND = '43d5f5ef41f5c4a9dea9bfd3d053f962.png'
const CONCIERGE_BACKGROUND = '41671ce2515d6b424b86893ec4436051.png'

const SERVICE_ITEMS = [
  { numberImage: num01, phoneImage: 'bb1e93badfef429bb0520a86268f90b1.png', titleKey: 'vip.services.items.hotelPrivileges.title' },
  { numberImage: num02, phoneImage: '0658357f39d94387122ec9a50b5765a1.png', titleKey: 'vip.services.items.fastTrack.title' },
  { numberImage: num03, phoneImage: 'ad4ffa56fe6976dac8fe513b32c703b2.png', titleKey: 'vip.services.items.personalShopping.title' },
  { numberImage: num04, phoneImage: 'ab485033a702763a9e7f8c231a4bbcd5.png', titleKey: 'vip.services.items.restaurantReservation.title' },
] as const

const CONCIERGE_ROWS = [
  [
    'vip.services.concierge.benefits.instantResponse',
    'vip.services.concierge.benefits.premiumReservations',
    'vip.services.concierge.benefits.itineraryAlerts',
    'vip.services.concierge.benefits.personalizedLifestyle',
  ],
  [
    'vip.services.concierge.benefits.emergencyAssistance',
    'vip.services.concierge.benefits.privilegeActivation',
    'vip.services.concierge.benefits.privacyProtection',
    'vip.services.concierge.benefits.multilingualCrossBorderSupport',
  ],
] as const

const BenefitPill = ({ lngKey }: { lngKey: string }) => (
  <div className="flex h-[44px] shrink-0 items-center gap-[8px] rounded-full bg-white px-[16px] text-[16px] leading-[22px] text-[#C98222] shadow-[0_2px_6px_rgba(177,109,18,0.08)]">
    <span className="flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full bg-[#DDA64E] text-[13px] font-bold text-white">
      ✓
    </span>
    <LangText lngKey={lngKey} className="whitespace-nowrap" />
  </div>
)

const BenefitGroup = ({ items }: { items: readonly string[] }) => (
  <div className="flex shrink-0 gap-[16px] pr-[16px]">
    {[0, 1].flatMap((repeatIndex) =>
      items.map((item) => <BenefitPill key={`${repeatIndex}-${item}`} lngKey={item} />),
    )}
  </div>
)

const BenefitMarquee = ({ items, duration }: { items: readonly string[]; duration: number }) => (
  <div
    className="overflow-hidden"
    style={{
      WebkitMaskImage: 'linear-gradient(to right, transparent, #000 7%, #000 93%, transparent)',
      maskImage: 'linear-gradient(to right, transparent, #000 7%, #000 93%, transparent)',
    }}
  >
    <div
      className="flex w-max"
      style={{ animation: `vip-concierge-marquee ${duration}s linear infinite` }}
    >
      <BenefitGroup items={items} />
      <BenefitGroup items={items} />
    </div>
  </div>
)

const ServiceContent = () => (
  <section
    className="h-[1134px] w-full overflow-hidden bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${preFixImgUrl(SERVICE_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col items-center pt-[60px]">
      <div className="flex flex-col items-center">
        <LangText lngKey="vip.services.title" className="text-[36px] font-bold leading-[50px] text-white" />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-white/15" />
      </div>

      <div className="mt-[36px] grid w-full grid-cols-4 gap-[40px]">
        {SERVICE_ITEMS.map((item) => (
          <article key={item.titleKey} className="flex flex-col items-center min-w-0">
            <div className="flex h-[60px] items-center justify-center">
              <img src={item.numberImage} alt="" className="object-contain w-auto h-full" aria-hidden />
            </div>
            <LangText
              lngKey={item.titleKey}
              className="mt-[-2px] font-smiley-sans text-[32px] font-medium leading-[38px] text-white"
            />
            <div className="mt-[20px] h-[538px] w-[265px] overflow-hidden">
              <img
                src={preFixImgUrl(item.phoneImage)}
                alt=""
                className="object-contain w-full h-full"
                draggable={false}
              />
            </div>
          </article>
        ))}
      </div>

      <div
        className="flex h-[178px] w-[1200px] shrink-0 overflow-hidden rounded-[20px] bg-cover bg-fill bg-no-repeat"
        style={{ backgroundImage: `url(${preFixImgUrl(CONCIERGE_BACKGROUND)})` }}
      >
        <div className="flex h-[178px] shrink-0 flex-col justify-center px-[42px]">
          <LangText
            lngKey="vip.services.concierge.title"
            className="font-smiley-sans text-[40px] font-medium leading-[48px] text-[#D07E26]"
          />
          <LangText
            lngKey="vip.services.concierge.description"
            className="mt-[16px] text-[20px] leading-[28px] text-[#666666]"
          />
        </div>

        <div className="flex min-w-0 flex-1 flex-col justify-center gap-[16px] overflow-hidden">
          <BenefitMarquee items={CONCIERGE_ROWS[0]} duration={24} />
          <BenefitMarquee items={CONCIERGE_ROWS[1]} duration={28} />
        </div>
      </div>
    </div>

    <style>
      {`
        @keyframes vip-concierge-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}
    </style>
  </section>
)

export default ServiceContent
